import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

export default function YearBox(props) {
  const { year, text } = props;
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.year}>{year}</Box>
      <Box className={classes.text}>{text}</Box>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    marginBottom: '20px',
  },
  year: {
    backgroundImage: 'url(/images/history_box.png)',
    color: theme.color.white,
    minWidth: '80px',
    maxWidth: '80px',
    height: '40px',
    margin: '0 16px 0 16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingLeft: '8px',
    boxSizing: 'border-box',
    fontSize: '16px',
    '@media only screen and (max-width:1024px)': {
      fontSize: '22px',
    },
    '@media only screen and (max-width:768px)': {
      fontSize: '14px',
    },
  },
  text: {
    // width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '16px',
    '@media only screen and (max-width:1024px)': {
      fontSize: '22px',
    },
    '@media only screen and (max-width:768px)': {
      fontSize: '12px',
    },
  },
}));
